import { Navigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import { auth } from "../lib/firebase";
import { isEmailVerified } from "../utils/emailVerification";

interface EmailVerificationGuardProps {
  children: JSX.Element;
  bypassForAdmin?: boolean;
}

export default function EmailVerificationGuard({ 
  children, 
  bypassForAdmin = false 
}: EmailVerificationGuardProps) {
  const { user, loading } = useAuthContext();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">กำลังโหลด...</p>
        </div>
      </div>
    );
  }

  // Check if admin is authenticated via AdminPasswordGuard
  if (bypassForAdmin) {
    const adminAuthData = sessionStorage.getItem('admin_authenticated');
    if (adminAuthData) {
      try {
        const { timestamp } = JSON.parse(adminAuthData);
        const now = Date.now();
        const SESSION_DURATION = 3600000; // 1 hour in milliseconds
        
        // Check if admin session is still valid
        if (now - timestamp < SESSION_DURATION) {
          return children;
        }
      } catch (e) {
        // Invalid session data, continue to normal flow
      }
    }
  }

  if (!user || !auth.currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Admin bypass if enabled (for Firebase users with admin role)
  if (bypassForAdmin && user.role === "admin") {
    return children;
  }

  // Coursedee: สมัคร/เข้าด้วย email ธรรมดา ไม่บังคับยืนยันอีเมล (ระบบส่งเมลถูกปิด)
  const hn = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hn.includes('aiforyou')) {
    return children;
  }

  // Check email verification
  if (!isEmailVerified(auth.currentUser)) {
    console.log('[EmailVerificationGuard] Email not verified, redirecting to /verify-email');
    return <Navigate to="/verify-email" replace />;
  }

  return children;
}
